import React, { useState } from "react";
import Header from "../../../components/Header/Header";
import Navbar from "../../../components/Header/Navbar";
import MobFooter from "../../../components/MobFooter";
import BetSlip from "../../../components/BetSlip";
import InPlay from "../../../components/InPlay";
import Tommorow from "../../../components/Tommorow";

const InPlayScreen = () => {
  const [activeButton, setActiveButton] = useState("inplay");

  function handleButtonClick(button) {
    setActiveButton(button);
  }
  return (
    <div>
      <Header />
      <Navbar />
      <div className="inplay  bg-[#f2ead5] h-[100vh] flex mx-[15px]">
        <div className="col-left w-[75%] px-[10px] py-[10px]">
          <div className="inplay_header">
            <div className=" ">
              <button
                className={`
                  border-radius
                 ${
                   activeButton === "inplay"
                     ? "inplay_button active"
                     : "inplay_button "
                 }
                `}
                onClick={() => handleButtonClick("inplay")}
              >
                InPlay
              </button>
              <button
                className={
                  activeButton === "today"
                    ? "inplay_button active"
                    : "inplay_button "
                }
                onClick={() => handleButtonClick("today")}
              >
                Today
              </button>
              <button
                className={`
                border_radius_right
                 ${
                   activeButton === "tomorrow"
                     ? "inplay_button  active "
                     : "inplay_button "
                 }
                    `}
                onClick={() => handleButtonClick("tomorrow")}
              >
                Tomorrow
              </button>
            </div>
          </div>
          {activeButton === "inplay" && <InPlay />}
          {activeButton === "tomorrow" && <Tommorow />}
        </div>
      </div>
      <MobFooter />
    </div>
  );
};

export default InPlayScreen;
